import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { LabTestArrayItem, LabTestGroup, LabTestList, LabTestRepeat, LabTestWithSampleDetails } from '../../models/labTestRepeat';
import { UserDetail } from '../../models/UserDetail';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../services/shared.service';
import { AuthService } from '../../services/auth.service';
import { ProjectService } from '../../services/project.service';
import { Filters, ProjectWithLabTest, SampleReport, SeparatorGasCompositionModel, SeparatorOilGraphModel, WellProjectsList, VwUserReportView, FractionReports, DisplayItem, CountryModel, WellModel, StatusModel, Project, SeparatorOilProcessModel, ComponentItem, FractionComponent, SeparatorGasReports, SeparatorOilReports } from '../../models/project';
import { MatDialog } from '@angular/material/dialog';
import { GenerateReportPopupComponent } from '../generate-report-popup/generate-report-popup.component';
import { BehaviorSubject, Observable, Subscription, firstValueFrom, forkJoin, map, startWith } from 'rxjs';
import { ReportSingleStageFlashGORData, CompRecombFinalDataModel, CompRecombQAQCFlashedSampleModel } from '../../bca/models/bca';
import { CVDReport } from '../../cvd/models/cvd';
import { Vw_DecontaminationUncontaminatedData, Vw_DecontaminationContaminatedData, Vw_DecontaminationPropertiesData, DeContaminationChart, DecontaminationReportData } from '../../liveoil-decontamination/models/decontamination';
import { SummaryOfBPTable, LabTestReportData, CCEReports, BPTable, BCAReports, ParaffinReports, viscosityReports, CCEDewPointReports, SummaryOfCCEReports, DPTable, ReportResponse, FinalResultCCE, RecombinationQCFinalReportDetails, FinalResultCCEDew, DecontaminationSaveDataReport, CVDFinalReport, ReportResult, FinalResultBCA, MSSTReportData, DLEReportData, FractionUpdate } from '../../models/lab-test';
import { LabTestEmail } from '../../models/lab-test-email';
import { MSSTCalculationResult, MSSTReport } from '../../msst/models/msst';
import { VWWellstreamCalculationModel, RecombinationQCReportData } from '../../recombination-qc/models/recombination-qc';
import { BCAService } from '../../bca/services/bca.service';
import { CceDewpointService } from '../../cce-dewpoint/services/cce-dewpoint.service';
import { CCEService } from '../../cce/services/cce.service';
import { CVDService } from '../../cvd/services/cvd.service';
import { DecontaminationService } from '../../liveoil-decontamination/services/decontamination.service';
import { MSSTService } from '../../msst/services/msst.service';
import { ParaffinService } from '../../paraffin/services/paraffin.service';
import { RecombinationQCService } from '../../recombination-qc/services/recombination-qc.service';
import { LabTestListService } from '../../services/labTestList.service';
import { ReportService } from '../../services/report.service';
import { ViscosityService } from '../../viscosity/services/viscosity.service';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { EMVViscosityData } from '../../viscosity/models/viscosity';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { reportConstants, roleIds, STATUS_CONSTANTS_UC } from '../../common/constants';
import { cceDPConstants, decontaminationConstants } from '../../common/experiment-constants';
import { SwellingFinalReport, SwellingSaveModel, Vw_SwellCalculatedCompositionalBalanceData, Vw_SwellInjectionGasCompositionData, Vw_SwellReportData } from '../../swell/models/swelling';
import { SwellingService } from '../../swell/services/swelling.service';
import { DLECalculationReport, DLEFullCompositionResult, DLEReport, DLESTOtoReservoirResult } from '../../dle/models/dle';
import { DleService } from '../../dle/services/dle.service';
import { SampleCreationService } from '../../services/sample-creation.service';
import { RfpodService } from '../../services/rfpod.service';
import { ProjectsListService } from '../../services/projects-list.service';
import { combineLatestWith, debounceTime, distinctUntilChanged, filter, finalize, takeUntil } from 'rxjs/operators'
import { environment } from '../../../environments/environment';
import { MESSAGES_CONSTANTS as MC } from '../../common/messages-constants';
import { projectListConstants } from '../../common/texts-constants';
import { NUMBERS_CONSTANTS } from '../../common/numbers-constants';
import { APIResponse } from '../../models/APIResponse';
import { ComponentMasters } from '../../models/shared';
import { ParaffinData } from '../../paraffin/models/paraffin';
import { LoadingService } from '../../services/loading.service';
import { RFPODReport } from '../../models/rfpod-report';
import { MaterialDesignModule } from '../../common/material-design/material-design.module';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
// import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import type { PDFDocumentProxy } from 'pdfjs-dist';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ReportPDFBuildersService } from '../../services/reportpdfbuilders/report.pdfBuilders.service';
@Component({
  selector: 'app-projects-list',
  templateUrl: './projects-list.component.html',
  styleUrl: './projects-list.component.scss',
  animations: [
    trigger(projectListConstants.detailExpand, [
      state(projectListConstants.collapsed, style({ display: projectListConstants.none })),
      state(projectListConstants.expanded, style({ width: projectListConstants.hundredPercent })),
      transition(`${projectListConstants.expanded} <=> ${projectListConstants.collapsed}`, animate(projectListConstants.animationTiming, keyframes([
        style({ left: projectListConstants.zero, top: projectListConstants.twoHundredPx, offset: NUMBERS_CONSTANTS.zero }),
        style({ left: projectListConstants.twoHundredPx, top: projectListConstants.oneHundredPx, offset: NUMBERS_CONSTANTS.pointFive }),
        style({ left: projectListConstants.fourHundredPx, top: projectListConstants.twoHundredPx, offset: NUMBERS_CONSTANTS.one }),
      ]))),
    ]),
  ],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialDesignModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    // NgxExtendedPdfViewerModule,
    PdfViewerModule
  ]
})
export class ProjectsListComponent implements OnInit, AfterViewInit, OnDestroy {
  readonly roleIds = roleIds;
  private projectService = inject(ProjectService);
  private cdr = inject(ChangeDetectorRef);
  private toastr = inject(ToastrService);
  public sharedService = inject(SharedService);
  private authService = inject(AuthService);
  private dialog = inject(MatDialog);
  private labTestListService = inject(LabTestListService);
  private reportService = inject(ReportService);
  private reportPDFBuildersService = inject(ReportPDFBuildersService);
  private cceHttp = inject(CCEService);
  private msstHttp = inject(MSSTService);
  private bcaHttp = inject(BCAService);
  private paraffinHttp = inject(ParaffinService);
  private viscosityHttp = inject(ViscosityService);
  private recombinationQcHttp = inject(RecombinationQCService);
  private cceDewPointHttp = inject(CceDewpointService);
  private decontaminationHttp = inject(DecontaminationService);
  private cvdHttp = inject(CVDService);
  private swellingHttp = inject(SwellingService);
  private dleHttp = inject(DleService);
  private sampleService = inject(SampleCreationService);
  private rfpodService = inject(RfpodService);
  private projectHttp = inject(ProjectService);
  private fb = inject(FormBuilder);
  private projectsListService = inject(ProjectsListService);
  private loadingService = inject(LoadingService);

  @ViewChild('outerSort', { static: true }) outerSort!: MatSort;
  @ViewChildren('innerSort') innerSort!: QueryList<MatSort>;
  @ViewChildren('innerTables') innerTables!: QueryList<MatTable<LabTestRepeat>>;
  @ViewChild('paginator') paginator!: MatPaginator;
  @ViewChild('paginator1') paginator1!: MatPaginator;
  @ViewChild('plotOilChart1') plotOilChart1Ref!: ElementRef<HTMLCanvasElement>;
  @ViewChild('plotOilChart2') plotOilChart2Ref!: ElementRef<HTMLCanvasElement>;
  @ViewChild('cceDewPointChart1') cceDewPointChart1Ref!: ElementRef<HTMLCanvasElement>;
  @ViewChild('cceDewPointChart2') cceDewPointChart2Ref!: ElementRef<HTMLCanvasElement>;
  @ViewChild('summaryOfCCEChart') summaryOfCCEChartRef!: ElementRef<HTMLCanvasElement>;
  @ViewChild('MatarialBalanceResult') materialBalanceResultRef!: ElementRef<HTMLCanvasElement>;
  @ViewChild('HoffmanFactorResult') hoffmanFactorResultRef!: ElementRef<HTMLCanvasElement>;
  @ViewChild('decontDeadOilChart') decontDeadOilChartRef!: ElementRef<HTMLCanvasElement>;
  @ViewChild('decontliveFluidChart') decontLiveFluidChartRef!: ElementRef<HTMLCanvasElement>;
  @ViewChild('swellingChart') swellingChartRef!: ElementRef<HTMLCanvasElement>;
  @ViewChild('viscosityChart') viscosityChartRef!: ElementRef<HTMLCanvasElement>;

  pageEvent: PageEvent = {
    pageIndex: environment.paginatorDefaults.pageIndex,
    pageSize: environment.paginatorDefaults.pageSize,
    length: environment.paginatorDefaults.length
  };
  pageEvent1: PageEvent = {
    pageIndex: environment.paginatorDefaults.pageIndex,
    pageSize: environment.paginatorDefaults.pageSize,
    length: environment.paginatorDefaults.length
  };
  pageSizeOptions = environment.pageSizeOptions;
  pageNumber: number = environment.paginatorDefaults.pageNumber;
  pageSize: number = environment.paginatorDefaults.pageSize;

  labTestRepeatList: LabTestRepeat[] = [];
  displayColumns = [...projectListConstants.displayColumns];
  innerDisplayedColumns = [...projectListConstants.innerDisplayedColumns];
  graphImages: string[] = [];
  dataSource = new MatTableDataSource<WellProjectsList>();
  dataSource1 = new MatTableDataSource<DisplayItem>();
  errorMessage!: string;
  successMessage!: string;
  filterValue = '';
  username: string | undefined;
  user!: UserDetail | undefined;
  expandedElement: WellProjectsList | null = null;
  filteredProjectsDataList: WellProjectsList[] = [];
  rotatedIndex: number | null = null;
  roleId = '';
  userId = '';

  chartList: unknown[] = [];
  formCCECalc!: FormGroup;
  graphDisplay = true;
  vSat = NUMBERS_CONSTANTS.zero;
  bubblePoint = NUMBERS_CONSTANTS.zero;
  trendAbove = NUMBERS_CONSTANTS.zero;
  trendBelow = NUMBERS_CONSTANTS.zero;

  selectedCountryId: number | null = null;
  countryValue = projectListConstants.all;
  wellValue = projectListConstants.all;
  statusValue = projectListConstants.all;

  startDate: Date | null = null;
  endDate: Date | null = null;

  filterForm!: FormGroup;
  filteredWells$: Observable<WellProjectsList[]> | undefined;

  private wellsSubject = new BehaviorSubject<WellProjectsList[]>([]);
  wells$ = this.wellsSubject.asObservable();

  countries: CountryModel[] = [];
  wells: WellModel[] = [];
  wellsLookup: WellModel[] = [];
  statusLookup: StatusModel[] = [];
  STATUS_CONSTANTS_UC = STATUS_CONSTANTS_UC;

  statusChart?: Chart;
  wellChart?: Chart;
  chartLegendListAll: DisplayItem[] = [];
  private pendingStatusCounts: { completed: number; inprogress: number; ready: number } | null = null;
  private pendingWellCounts: { name: string | null; count: number }[] | null = null;
  private chartRenderRetryHandle: ReturnType<typeof setTimeout> | null = null;
  @ViewChild('legendDialog') legendDialog!: TemplateRef<unknown>;
  @ViewChild('legendDialogPrivew') legendDialogPrivew!: TemplateRef<unknown>;
  private dateRangeSub!: Subscription;
  private filteredWellsSub!: Subscription;
  private userDetailSub!: Subscription;
  private authSub!: Subscription;

  private readonly STATUS_COLORS = {
    completed: projectListConstants.green,  // green
    inprogress: projectListConstants.orange, // orange
    ready: projectListConstants.blue       // blue
  };

  @ViewChild('statusPieChart')
  statusPieChart!: ElementRef<HTMLCanvasElement>

  @ViewChild('wellPieChart')
  wellPieChart!: ElementRef<HTMLCanvasElement>;
  canvasWidth = projectListConstants.canvasWidth;
  canvasHeight = projectListConstants.canvasHeight;
  preview = false;
  pdfData!: Uint8Array;
  ngOnInit() {

    this.filterForm = this.fb.group({
      search: [''],
      country: [projectListConstants.al],
      well: [projectListConstants.al],
      dateRange: this.fb.group({
        start: [null],
        end: [null],
      }),
      status: [projectListConstants.al],
    });

    const { start, end } = this.sharedService.GetSameDayLastMonthRange(new Date());
    this.filterForm.patchValue({ dateRange: { start, end } });

    this.dateRangeSub = this.filterForm.get('dateRange')!.valueChanges.pipe(
      debounceTime(NUMBERS_CONSTANTS.oneFifty),
      map(v => ({ start: v?.start ?? null, end: v?.end ?? null })),
      filter(v => !!v.start && !!v.end),
      distinctUntilChanged((a, b) =>
        a.start?.getTime?.() === b.start?.getTime?.() &&
        a.end?.getTime?.() === b.end?.getTime?.()
      )
    ).subscribe(() => this.GetProjectsListData());

    const filters$ = this.filterForm.valueChanges.pipe(startWith(this.filterForm.value as Filters));

    this.filteredWells$ = this.wells$.pipe(
      combineLatestWith(filters$),
      map(([wellsList, filters]) => {
        const visible = wellsList.filter(w => this.ShowWell(w, filters));
        return visible.map(w => {
          const wellMatched = this.WellMatchesToken1(w, filters.search);
          const filteredProjects = this.FilterProjectsForWell(w.projects ?? [], filters);
          return {
            ...w,
            projects: filteredProjects,
            _wellMatched: wellMatched
          };
        });
      })
    );

    this.filteredWellsSub = this.filteredWells$.subscribe(filtered => {
      this.dataSource.data = filtered;
      this.UpdateChartsFrom(filtered);
    });

    this.userDetailSub = this.sharedService.userDetail$.subscribe((userDetail) => {
      if (userDetail) {
        this.userId = userDetail?.mail;
      }
    });
    this.authSub = this.authService.isCookieAttached$.subscribe((response) => {
      if (response === true) {
        this.sharedService
          .GetUserDetail()
          .subscribe({
            next: (apiResponse) => {
              if (apiResponse.isSuccess) {
                const roleName = apiResponse.result.roleName;
                if (roleName === roleIds.fluidEngineer || roleName === roleIds.labTech || roleName === roleIds.techResource) {
                  this.user = apiResponse.result;
                  this.sharedService.UpdateUserDetail(this.user);
                  this.username = this.user?.displayName;
                  const roleId = apiResponse.result.roleName;
                  this.sharedService.UpdateUserRoleId(roleId);
                  this.roleId = roleId;
                  this.GetProjectsListData();
                } else {
                  this.toastr.error(MC.accessDenied);
                  setTimeout(async () => {
                    await this.authService.ClearAuthCookie();
                    this.sharedService.NavigateToAccessError();
                  }, NUMBERS_CONSTANTS.twoThousand);
                }
              } else {
                setTimeout(async () => {
                  await this.authService.ClearAuthCookie();
                  await this.authService.Logout();
                }, NUMBERS_CONSTANTS.twoHundred);
              }
            },
            error: (error) => {
              if (error.status === 404) {
                setTimeout(async () => {
                  await this.authService.ClearAuthCookie();
                  await this.authService.Logout();
                }, NUMBERS_CONSTANTS.twoHundred);
              }
            }
          });
      }
      else {
        this.sharedService.NavigateToLogin();
      }
    });
  }

  ngAfterViewInit() {
    // Initialize outer table sorting
    this.dataSource.sort = this.outerSort;
    this.graphDisplay = false;
  }

  ngOnDestroy(): void {
    this.dateRangeSub?.unsubscribe();
    this.filteredWellsSub?.unsubscribe();
    this.userDetailSub?.unsubscribe();
    this.authSub?.unsubscribe();
    if (this.chartRenderRetryHandle) {
      clearTimeout(this.chartRenderRetryHandle);
      this.chartRenderRetryHandle = null;
    }
  }

  // --- Search Filter
  private projectFilterPredicate = (row: Project, filter: string): boolean =>
    this.projectsListService.ProjectFilterPredicate(row, filter);

  private outerFilterPredicate = (well: WellProjectsList, filter: string): boolean =>
    this.projectsListService.OuterFilterPredicate(well, filter, this.startDate, this.endDate);

  // Get List of Projects
  GetProjectsListData() {
    this.loadingService.ShowLoadingSpinner();
    const dr = this.filterForm?.value?.dateRange;
    const fromDateStr = this.sharedService.ToLocalDateStringOrNull(dr?.start);
    const toDateStr = this.sharedService.ToLocalDateStringOrNull(dr?.end);

    this.projectService.GetProjectsList(fromDateStr, toDateStr).subscribe((response) => {
      if (response.result) {
        this.filteredProjectsDataList = this.projectsListService.SortWellsByLatestProjectDate(
          response.result as WellProjectsList[]
        );
        this.dataSource.data = this.filteredProjectsDataList;
        this.dataSource.paginator = this.paginator;

        // ---------- outer predicate ----------
        this.dataSource.filterPredicate = this.outerFilterPredicate;

        this.wellsSubject.next(this.filteredProjectsDataList);

        this.GetCountries();
        this.wellsLookup = this.projectsListService.BuildDefaultWellsLookup();
        this.GetStatus();
      } else {
        this.errorMessage = MC.anErrorOccurredWhileFetchingTheData;
        this.toastr.error(this.errorMessage);
      }
      this.loadingService.HideLoadingSpinner();
    });
  }

  getRowNumber(i: number): number {
    const pageIndex = this.paginator ? this.paginator.pageIndex : this.pageEvent.pageIndex;
    const pageSize = this.paginator ? this.paginator.pageSize : this.pageEvent.pageSize;
    return i + NUMBERS_CONSTANTS.one + (pageIndex * pageSize);
  }

  OnPageChange(event: PageEvent) {
    this.pageNumber = event.pageIndex + NUMBERS_CONSTANTS.one;
    this.pageSize = event.pageSize;
    this.GetProjectsListData();
  }

  ToggleRow(element: WellProjectsList, index: number | null) {
    this.rotatedIndex = this.rotatedIndex === index ? null : index;

    if (element.projects && element.projects.length) {
      this.expandedElement = this.expandedElement === element ? null : element;
    }

    this.cdr.detectChanges();

    if (this.expandedElement === element) {
      setTimeout(() => {
        this.AssignInnerTableSorting();
      }, NUMBERS_CONSTANTS.twoHundred);

      // Fallback attempt
      setTimeout(() => {
        this.AssignInnerTableSorting();
      }, NUMBERS_CONSTANTS.fiveHundred);
    }

  }

  private AssignInnerTableSorting() {
    if (!this.innerTables || !this.innerSort) {
      return;
    }

    const innerTablesArray = this.innerTables.toArray();
    const innerSortArray = this.innerSort.toArray();

    if (innerTablesArray.length === NUMBERS_CONSTANTS.zero || innerSortArray.length === NUMBERS_CONSTANTS.zero) {
      return;
    }

    innerTablesArray.forEach((table, i) => {
      if (table && innerSortArray[i]) {
        if (!(table.dataSource instanceof MatTableDataSource)) {
          const data = Array.isArray(table.dataSource) ? table.dataSource : [];
          table.dataSource = new MatTableDataSource(data);
        }

        const ds = table.dataSource as MatTableDataSource<Project>;
        ds.sort = innerSortArray[i];

        // ---------- inner predicate + current filter ----------
        ds.filterPredicate = this.projectFilterPredicate;
        ds.filter = this.filterValue;

        table.renderRows();
      }
    });
  }

  // Navigate to Experiment page
  NavigateProjectDetail(expandedElement: ProjectWithLabTest) {
    const projectId = expandedElement.projectId;
    this.sharedService.NavigateToProjectDetail(projectId);
  }

  NavigateCreateProject() {
    this.sharedService.NavigateToCreateProject();
  }

  // Open Popup to Select Experiments to Generate Report
  OpenGenerateReportPopup(element: ProjectWithLabTest) {
    const acceptedExperimentList = this.projectsListService.GetAcceptedCompletedExperiments(
      element.labTestListData as LabTestWithSampleDetails[]
    );

    if (acceptedExperimentList.length) {
      const groupedData = this.FilterLabTestDataList(acceptedExperimentList);
      const dialogRef = this.dialog.open(GenerateReportPopupComponent, {
        data: {
          groupedData,
          projectID: element.projectId,
        }
      });
      const componentInstance = dialogRef.componentInstance;
      componentInstance.previewEvent.pipe(
        takeUntil(dialogRef.afterClosed())
      ).subscribe(async (result) => {
        this.loadingService.ShowLoadingSpinner();

        try {
          this.preview = result.preview;

          const groupedResult = this.GroupByLabTestId(result.finalArray);

          await Promise.all(groupedResult.map(async item => {
            const labtest = groupedData.find(
              (data: LabTestWithSampleDetails) => data.labTestId === item.labTestId
            ) as LabTestWithSampleDetails;

            await this.GenerateReport(
              labtest,
              item.items,
              result.pdfSelected,
              result.excelSelected,
              result.projectID
            );
          }));

        } finally {
          this.loadingService.HideLoadingSpinner();
        }
      });

      dialogRef.afterClosed().subscribe(async (result) => {
        if (result !== undefined) {
          this.loadingService.ShowLoadingSpinner();
          try {
            this.preview = result.preview;
            const groupedResult = this.GroupByLabTestId(result.finalArray);
            await Promise.all(groupedResult.map(async item => {
              const labtest = groupedData.filter((data: LabTestWithSampleDetails) => data.labTestId === item.labTestId)[0] as LabTestWithSampleDetails;
              await this.GenerateReport(labtest, item.items, result.pdfSelected, result.excelSelected, result.projectID);
            }));
          } finally {
            this.loadingService.HideLoadingSpinner();
          }
        }
      });
    }
    else {
      this.toastr.warning(MC.noCompletedSamplesWithAcceptedRecordsInThisProject)
    }
  }

  FilterLabTestDataList(response: LabTestWithSampleDetails[]): LabTestWithSampleDetails[] {
    return this.projectsListService.FilterLabTestDataList(response);
  }

  GroupByLabTestId(data: LabTestRepeat[]): LabTestGroup[] {
    return this.projectsListService.GroupByLabTestId(data);
  }

  // Generate PDF Report of sample
  async GenerateReport(element: LabTestWithSampleDetails, selectedLabTestRepeatList: LabTestRepeat[], pdfSelected: boolean, excelSelected: boolean, projectID: number) {
    const requests: Observable<APIResponse<ReportResponse>>[] = [];
    const graphPromises: Promise<void>[] = [];
    const labTestArray: LabTestArrayItem[] = this.projectsListService.BuildLabTestArray(
      element,
      selectedLabTestRepeatList
    );
    const expResults: ReportResult[] = [];
    const summaryTable: SummaryOfBPTable[] = [];
    const summaryTableDew: SummaryOfBPTable[] = [];
    const labReportData: LabTestReportData = {
      dataLabTest: [],
      expResults: []
    };
    selectedLabTestRepeatList.map((labTest: LabTestRepeat) => {
      if (labTest.statusName === projectListConstants.accepted) {
        const experimentShortName = labTest.experimentName;
        switch (experimentShortName) {
          case reportConstants.experimentNameCCE:
            requests.push(this.cceHttp.GetCCEReport(labTest.labTestRepeatId));
            break;
          case reportConstants.experimentNameMSST:
            requests.push(this.msstHttp.GetMSSTReport(labTest.labTestRepeatId));
            break;
          case reportConstants.experimentNameBCA:
            requests.push(this.bcaHttp.GetBCAReport(labTest.labTestRepeatId));
            break;
          case reportConstants.experimentNameParaffin:
            requests.push(this.paraffinHttp.GetParaffin(labTest.labTestRepeatId));
            break;
          case reportConstants.experimentNameViscosity:
            requests.push(this.viscosityHttp.GeViscosity(labTest.labTestRepeatId));
            break;
          case reportConstants.experimentNameRecombination:
            requests.push(this.recombinationQcHttp.GetFinalReportRecombinationQC(labTest.labTestRepeatId));
            break;
          case reportConstants.experimentNameCCEDewPoint:
            requests.push(this.cceDewPointHttp.GetCCEDewPointReport(labTest.labTestRepeatId));
            break;
          case reportConstants.experimentNameDecontamination:
            requests.push(this.decontaminationHttp.GetFinalReportDecontamination(labTest.labTestRepeatId));
            break;
          case reportConstants.experimentNameCVD:
            requests.push(this.cvdHttp.GetCVDReport(labTest.labTestRepeatId));
            break;
          case reportConstants.experimentNameDLE:
            requests.push(this.dleHttp.GetDLEReport(labTest.labTestRepeatId));
            break;
          case reportConstants.experimentNameSwelling:
            requests.push(this.swellingHttp.GetFinalReportSwelling(labTest.labTestRepeatId));
            break;
        }
      }
    });
    if ((element.reportSampletype ?? '').toLowerCase() == reportConstants.reportTypeSeparatorTest) {
      const experName = projectListConstants.separatoroil;
      switch (experName) {
        case projectListConstants.sepOil:
          requests.push(this.projectService.GetSeparatorOilCompositionFinalReport(experName, element.labTestId));
      }

      const expName = projectListConstants.separatorgas;
      switch (expName) {
        case projectListConstants.sepGas:
          requests.push(this.projectService.GetSeparatorGasCompositionFinalReport(expName, element.labTestId));
      }
    }
    if (labTestArray !== undefined && labTestArray.length > NUMBERS_CONSTANTS.zero)
      labReportData.dataLabTest = labTestArray;
    requests.push(this.sharedService.GetComponentMasters());
    requests.push(this.sampleService.GetSampleDetailsForFinalReport(element.labTestId, projectID));

    const resData = await firstValueFrom(forkJoin(requests));

    resData.forEach(results => {
      const resultsResponse = results.result as ComponentMasters;
      const resultsResponseWell = results.result as SampleReport;
      if (results.result !== null) {
        if (resultsResponse.components !== undefined) {
          const fraction: FractionReports = {
            experimentName: reportConstants.experimentNameFraction,
            components: this.TransformComponents(resultsResponse.components as ComponentItem[])
          }
          expResults.push(fraction);
        }
        else if (resultsResponseWell.wellInformationList !== undefined) {
          const dataSample: SampleReport = resultsResponseWell
          dataSample.rows = dataSample?.samplingInformation?.rows;
          if ((element.reportSampletype ?? '').toLowerCase() !== reportConstants.reportTypeSeparatorTest) {

            if (dataSample.samplingInformation?.rows) {
              dataSample.samplingInformation.rows =
                dataSample.samplingInformation?.rows.filter(
                  (item, index, self) =>
                    index === self.findIndex(
                      x =>
                        x.sampleIdentifier?.toLowerCase() ===
                        item.sampleIdentifier?.toLowerCase()
                    )
                );
            }
          }
          const fraction: FractionUpdate = {
            experimentName: reportConstants.experimentNameSampleDetails,
            data: dataSample
          }
          expResults.push(fraction);
        }
        else if (
          Array.isArray(results.result) &&
          results.result.length > NUMBERS_CONSTANTS.zero &&
          (results.result[0]?.sheetOne || results.result[0]?.sheetTwo)
        ) {
          const separatorOilGraphModels = (results.result as SeparatorOilProcessModel[])
            .map(r => r.sheetThree?.separatorOilGraphModels ?? [])
            .filter(Boolean)
            .flat();
          this.GenerateReportSeparatorOilGraph(separatorOilGraphModels);
          expResults.push({
            experimentName: reportConstants.experimentNameSeparatorOil,
            data: results.result,
            graphImages: [...this.graphImages] // base64 PNGs
          } as SeparatorOilReports);
          this.graphImages = [];
        }

        // Separator Gas
        else if (
          Array.isArray(results.result) && results.result.length > NUMBERS_CONSTANTS.zero &&
          results.result[0]?.rows) {
          results.result.forEach(
            (model: SeparatorGasCompositionModel) => {
              if (model.rows && model.rows.length > NUMBERS_CONSTANTS.zero) {
                const separatorGasData: SeparatorGasReports = {
                  experimentName: reportConstants.experimentNameSeparatorGas,
                  data: model.rows,
                  subTitle: model.subTitle
                };
                expResults.push(separatorGasData);
              }
            }
          );
        }

        else {
          const responseCCE = results.result as FinalResultCCE;
          const labTestExpDetails: LabTestArrayItem[] = labTestArray.filter(labTestVal => labTestVal.labTestRepeatId === responseCCE.labRepeatId);
          let experimentShortName: string | undefined;
          if (labTestExpDetails && labTestExpDetails.length > NUMBERS_CONSTANTS.zero) {
            experimentShortName = labTestExpDetails[0].experimentName;
          }
          switch (experimentShortName) {
            case reportConstants.experimentNameCCE: {
              const responseCCE = results.result as FinalResultCCE
              if (responseCCE.cceResultOilTable) {
                const cceData = responseCCE.cceResultOilTable as CCEReports;
                this.GenerateReportCCEGraph(cceData.bpTable);
                const dataCCE: CCEReports = ({
                  bpTable: cceData.bpTable,
                  cceProperties: cceData.cceProperties,
                  graphData: this.graphImages,
                  experimentName: labTestExpDetails[0].experimentName,
                  experimentSequenceNo: labTestExpDetails[0].experimentSequenceNo,
                  experimentFullName: labTestExpDetails[0].experimentFullName,
                  labRepeatId: responseCCE.labRepeatId,
                  sampleIdentifier: ""
                });
                const summaryData: SummaryOfBPTable = {
                  temp: cceData.cceProperties.studyTemperature,
                  psat: cceData.bpTable.find((x: BPTable) => x.pointName === projectListConstants.satP)?.pressure || NUMBERS_CONSTANTS.zero,
                  systemType: projectListConstants.pb,
                  relativeVolume: (cceData.bpTable.find((x: BPTable) => x.pointName === projectListConstants.satP)?.vVSat || NUMBERS_CONSTANTS.zero).toFixed(4),
                  densityAtPsat: cceData.bpTable.find((x: BPTable) => x.pointName === projectListConstants.satP)?.lVMassDens || NUMBERS_CONSTANTS.zero,
                  labRepeatId: responseCCE.labRepeatId,
                  sampleIdentifier: ""
                };
                if (cceData.cceProperties.isSwelling === false) {
                  summaryTable.push(summaryData);
                }
                expResults.push(dataCCE);
              }
              break;
            }
            case reportConstants.experimentNameMSST: {
              let msstCalc!: MSSTReport;
              const responseMSST = results.result as MSSTReport;
              if (responseMSST !== null && responseMSST !== undefined) {
                msstCalc = {

                  msstPropertyData: responseMSST.msstPropertyData,

                  separatorTestResult: responseMSST.separatorTestResult,
                  vaporCompositionResult: responseMSST.vaporCompositionResult,
                  residualOilCompositionResult: responseMSST.residualOilCompositionResult,
                  reservoirtoSTOResult: responseMSST.reservoirtoSTOResult,
                  stoToReservoirResult: responseMSST.stoToReservoirResult,
                  fullCompositionResult: responseMSST.fullCompositionResult,
                  materialBalanceSummaryResult: responseMSST.materialBalanceSummaryResult,
                  labRepeatId: responseMSST.labRepeatId,
                }
                const msstData: MSSTReportData = {
                  msstData: msstCalc as MSSTCalculationResult,
                  experimentName: labTestExpDetails[0].experimentName,
                  experimentSequenceNo: labTestExpDetails[0].experimentSequenceNo,
                  experimentFullName: labTestExpDetails[0].experimentFullName,
                  labRepeatId: responseMSST.labRepeatId,
                  sampleIdentifier: ""
                }
                expResults.push(msstData);

              }

              break;
            }
            case reportConstants.experimentNameBCA: {
              const bca = results.result as FinalResultBCA;
              if (bca.bcaCalculation !== undefined) {
                this.GenerateReportBCAGraph(bca.bcaCalculation.compRecombQAQCFlashedSample);
                const bcaData: BCAReports = {
                  bcaData: bca.bcaInput,
                  graphData: this.graphImages,
                  experimentName: labTestExpDetails[0].experimentName,
                  experimentSequenceNo: labTestExpDetails[0].experimentSequenceNo,
                  experimentFullName: labTestExpDetails[0].experimentFullName,
                  report: bca.bcaCalculation.reportSingleStageFlashGORData as ReportSingleStageFlashGORData,
                  reportCompositionData: bca.bcaCalculation.reportCompositionData as CompRecombFinalDataModel[],
                  labRepeatId: bca.labRepeatId,
                  sampleIdentifier: ""
                }
                expResults.push(bcaData);
              }
              break;
            }
            case reportConstants.experimentNameParaffin:
              if (results.result !== null && results.result !== undefined) {
                const responseParaffin = results.result as ParaffinData;
                const paraffinData: ParaffinReports = {
                  paraffinData: responseParaffin.paraffinWeights,
                  experimentName: labTestExpDetails[0].experimentName,
                  experimentSequenceNo: labTestExpDetails[0].experimentSequenceNo,
                  experimentFullName: labTestExpDetails[0].experimentFullName,
                  labRepeatId: responseParaffin.labRepeatId,
                  sampleIdentifier: ""
                }
                expResults.push(paraffinData);
              }
              break;

            case reportConstants.experimentNameViscosity:
              if (results.result !== null && results.result !== undefined) {
                const responseViscosity = results.result as EMVViscosityData
                graphPromises.push(
                  this.CreateViscosityGraphImages(responseViscosity).then(imgs => {
                    const viscosityData: viscosityReports = {
                      viscosityData: responseViscosity.viscosityData,
                      experimentName: labTestExpDetails[0].experimentName,
                      experimentSequenceNo: labTestExpDetails[0].experimentSequenceNo,
                      experimentFullName: labTestExpDetails[0].experimentFullName,
                      resP: responseViscosity?.resP ?? 0,
                      satP: responseViscosity.satP,
                      rangeFrom: responseViscosity?.rangeFrom ?? 0,
                      rangeTo: responseViscosity?.rangeTo ?? 0,
                      slope: responseViscosity?.slope ?? 0,
                      intercept: responseViscosity?.intercept ?? 0,
                      graphData: imgs,
                      labRepeatId: responseViscosity.labRepeatId,
                      sampleIdentifier: ""
                    };
                    expResults.push(viscosityData);
                  })
                );
              }
              break;
            case reportConstants.experimentNameRecombination:
              if (results.result !== null && results.result !== undefined) {
                const responseRCQC = results.result as RecombinationQCFinalReportDetails
                const recombinationData: VWWellstreamCalculationModel[] = responseRCQC.wellStreamCalculation;
                const recombinationReportData: RecombinationQCReportData = {
                  recombinationData: recombinationData,
                  experimentName: labTestExpDetails[0].experimentName,
                  experimentSequenceNo: labTestExpDetails[0].experimentSequenceNo,
                  experimentFullName: labTestExpDetails[0].experimentFullName,
                  labRepeatId: responseRCQC.labRepeatId,
                  sampleIdentifier: ""
                }
                expResults.push(recombinationReportData);
              }
              break;
            case reportConstants.experimentNameCCEDewPoint: {
              const responseCCEDew = results.result as FinalResultCCEDew
              if (responseCCEDew.cceResultGasTable) {
                const cceDewPoint = responseCCEDew.cceResultGasTable as CCEDewPointReports;
                this.GenerateReportCCEDewPointGraph(cceDewPoint.dpTable);
                const dataCCEDewPoint: CCEDewPointReports = ({
                  dpTable: cceDewPoint.dpTable,
                  cceDewPointProperties: cceDewPoint.cceDewPointProperties,
                  graphData: this.graphImages,
                  experimentName: labTestExpDetails[0].experimentName,
                  experimentSequenceNo: labTestExpDetails[0].experimentSequenceNo,
                  experimentFullName: labTestExpDetails[0].experimentFullName,
                  labRepeatId: responseCCEDew.labRepeatId,
                  sampleIdentifier: ""
                });
                const summaryData: SummaryOfBPTable = {
                  temp: cceDewPoint.cceDewPointProperties.studyTemperature,
                  psat: cceDewPoint.dpTable.find((x: BPTable) => x.pointName === projectListConstants.pSat)?.pressure || NUMBERS_CONSTANTS.zero,
                  systemType: projectListConstants.pd,
                  relativeVolume: (cceDewPoint.dpTable.find((x: BPTable) => x.pointName === projectListConstants.pSat)?.vVSat || NUMBERS_CONSTANTS.zero).toFixed(4),
                  densityAtPsat: cceDewPoint.dpTable.find((x: BPTable) => x.pointName === projectListConstants.pSat)?.lVMassDens || NUMBERS_CONSTANTS.zero,
                  labRepeatId: responseCCEDew.labRepeatId,
                  sampleIdentifier: ""
                };
                if (cceDewPoint.cceDewPointProperties.isSwelling === false) {
                  summaryTableDew.push(summaryData);
                }
                expResults.push(dataCCEDewPoint);
              }
              break;
            }
            case reportConstants.experimentNameDecontamination:
              if (results.result !== null && results.result !== undefined) {
                const responseDecontamidation = results.result as DecontaminationSaveDataReport;
                const vw_UncontaminatedData: Vw_DecontaminationUncontaminatedData[] = responseDecontamidation?.vw_DecontaminationUncontaminated ?? [];
                const vw_ContaminatedData: Vw_DecontaminationContaminatedData = responseDecontamidation?.vw_DecontaminationContaminated ?? {};
                const vw_PropertiesData: Vw_DecontaminationPropertiesData = responseDecontamidation?.vw_DecontaminationProperties ?? {};
                const contaminatedFluidGraphData = this.decontaminationHttp.GetChartData(
                  responseDecontamidation.contaminationFlashedCalcData ?? [], decontaminationConstants.calculatedFlashedLiquidWtPct);
                const contaminantGraphData = this.decontaminationHttp.GetChartData(
                  responseDecontamidation.contaminationFlashedCalcData ?? [], decontaminationConstants.calculatedContaminantCompositionWt);
                const contaminatedWholeFluidData = this.decontaminationHttp.GetChartData(
                  responseDecontamidation.deadLiveCalcData ?? [], decontaminationConstants.calculatedDeadUncontWtPct);
                const deContaminatedGraphData = this.decontaminationHttp.GetChartData(
                  responseDecontamidation.contaminationFlashedCalcData ?? [], decontaminationConstants.calculatedWholeFluidWtPct);
                const liveOilDeContaminatedGraphData = this.decontaminationHttp.GetChartData(
                  responseDecontamidation.deadLiveCalcData ?? [], decontaminationConstants.calculatedLiveUncontWtPct);
                // Combine arrays into one
                const combinedChartData = this.projectsListService.BuildDecontaminationChartData(
                  contaminatedFluidGraphData,
                  contaminantGraphData,
                  contaminatedWholeFluidData,
                  deContaminatedGraphData,
                  liveOilDeContaminatedGraphData
                );
                this.GenerateReportDecontaminationGraph(combinedChartData);
                const decontaminationReportData: DecontaminationReportData = {
                  dcontTable: responseDecontamidation.DConTable,
                  vw_DecontaminationUncontaminated: vw_UncontaminatedData,
                  vw_DecontaminationContaminated: vw_ContaminatedData,
                  vw_DecontaminationProperties: vw_PropertiesData,
                  deadOilGraphData: this.graphImages,
                  experimentName: labTestExpDetails[0].experimentName,
                  experimentSequenceNo: labTestExpDetails[0].experimentSequenceNo,
                  experimentFullName: labTestExpDetails[0].experimentFullName,
                  labRepeatId: responseDecontamidation.labRepeatId,
                  sampleIdentifier: ""
                }
                expResults.push(decontaminationReportData);
              }
              break;

            case reportConstants.experimentNameCVD: {
              let cvdCalc!: CVDReport;
              const cvdFinalReportDetails = results.result as CVDFinalReport;
              if (results.result !== null && results.result !== undefined) {
                cvdCalc = {
                  cvdStageResult: cvdFinalReportDetails.cvdStagesResult,
                  vaporCompositionResult: cvdFinalReportDetails.cvdVapor,
                  lastStageOilCompositionResult: cvdFinalReportDetails.cvdLastStageOil,
                  materialBalanceSummaryResult: cvdFinalReportDetails.cvdMaterialBalance,
                  labRepeatId: cvdFinalReportDetails.labRepeatId,
                }
                const cvdData = {
                  cvdData: cvdCalc,
                  experimentName: labTestExpDetails[0].experimentName,
                  experimentSequenceNo: labTestExpDetails[0].experimentSequenceNo,
                  experimentFullName: labTestExpDetails[0].experimentFullName,
                  labRepeatId: cvdFinalReportDetails.labRepeatId,
                  sampleIdentifier: ""
                }
                expResults.push(cvdData);
              }
              break;
            }
            case reportConstants.experimentNameDLE: {
              let dleReport!: DLECalculationReport;
              const dleReportDetails = results.result as DLEReport;
              if (results.result !== null && results.result !== undefined) {
                dleReport = {
                  diffLibResult: dleReportDetails.diffLibResult,
                  vaporStageCompositionResult: dleReportDetails.vaporStageCompositionResult,
                  residualOilCompositionResult: dleReportDetails.residualOilCompositionResult,
                  materialBalanceSummaryResult: dleReportDetails.materialBalanceSummaryResult,
                  labRepeatId: dleReportDetails.labRepeatId,
                  reservoirToSTOResult: [],
                  stoToReservoirResult: {} as DLESTOtoReservoirResult,
                  fullCompositionResult: {} as DLEFullCompositionResult
                }
                const dleData: DLEReportData = {
                  dleData: dleReport,
                  experimentName: labTestExpDetails[0].experimentName,
                  experimentSequenceNo: labTestExpDetails[0].experimentSequenceNo,
                  experimentFullName: labTestExpDetails[0].experimentFullName,
                  labRepeatId: dleReportDetails.labRepeatId,
                  sampleIdentifier: ""
                }
                expResults.push(dleData);
              }
              break;
            }
            case reportConstants.experimentNameSwelling: {
              const swellingSaveModelDetails = results.result as SwellingSaveModel;
              if (results.result !== null && results.result !== undefined) {
                const swellReport: Vw_SwellReportData[] = swellingSaveModelDetails.swellReport as Vw_SwellReportData[];
                const swellInjectionGasComposition: Vw_SwellInjectionGasCompositionData[] = swellingSaveModelDetails.swellInjectionGasComposition as Vw_SwellInjectionGasCompositionData[];
                const swellCalculatedCompositionalBalance: Vw_SwellCalculatedCompositionalBalanceData[] = swellingSaveModelDetails.swellCalculatedCompositionalBalance as Vw_SwellCalculatedCompositionalBalanceData[];
                this.GenerateSwellingReportGraph(swellReport);
                const swellingData: SwellingFinalReport = {
                  swellReport: swellReport,
                  swellInjectionGasComposition: swellInjectionGasComposition,
                  swellCalculatedCompositionalBalance: swellCalculatedCompositionalBalance,
                  swellReportGraphData: this.graphImages,
                  experimentName: labTestExpDetails[0].experimentName,
                  experimentSequenceNo: labTestExpDetails[0].experimentSequenceNo,
                  experimentFullName: labTestExpDetails[0].experimentFullName,
                  labRepeatId: swellingSaveModelDetails.labRepeatId,
                  sampleIdentifier: ""
                }
                expResults.push(swellingData);
              }
              break;
            }
          }
        }
      }
    })

    await Promise.all(graphPromises);

    const summaryRowsCCE = this.projectsListService.AttachSummarySampleIdentifiers(summaryTable, labReportData.dataLabTest);
    const groupedSummaryOfCCE = this.projectsListService.GroupSummaryBySampleIdentifier(summaryRowsCCE);

    const summaryRowsCCEDew = this.projectsListService.AttachSummarySampleIdentifiers(summaryTableDew, labReportData.dataLabTest);
    const groupedSummaryOfCCEDew = this.projectsListService.GroupSummaryBySampleIdentifier(summaryRowsCCEDew);
    //summary of cce
    if (summaryRowsCCE.length > NUMBERS_CONSTANTS.zero) {

      Object.entries(groupedSummaryOfCCE).forEach(([sampleId, items]: [string, SummaryOfBPTable[]]) => {
        const sortedDataDesc = this.projectsListService.SortSummaryByTemperatureDesc(items);
        this.GenerateReportSummaryCCEGraph(sortedDataDesc);
        const dataSummaryCCEPoint: SummaryOfCCEReports = ({
          bpTable: sortedDataDesc,
          graphData: this.graphImages,
          experimentName: projectListConstants.summaryOfCCE,
          experimentSequenceNo: NUMBERS_CONSTANTS.zero,
          experimentFullName: projectListConstants.summaryOfCCE,
          sampleIdentifier: sampleId
        });
        expResults.push(dataSummaryCCEPoint);
      });

    }
    //summary of cce dew point
    if (summaryRowsCCEDew.length > NUMBERS_CONSTANTS.zero) {
      Object.entries(groupedSummaryOfCCEDew).forEach(([sampleId, items]: [string, SummaryOfBPTable[]]) => {
        const sortedDataDesc = this.projectsListService.SortSummaryByTemperatureDesc(items);
        this.GenerateReportSummaryCCEGraph(sortedDataDesc);
        const dataSummaryCCEPoint: SummaryOfCCEReports = ({
          bpTable: sortedDataDesc,
          graphData: this.graphImages,
          experimentName: projectListConstants.summaryOfCCEDewPoint,
          experimentSequenceNo: NUMBERS_CONSTANTS.zero,
          experimentFullName: projectListConstants.summaryOfCCEDewPoint,
          sampleIdentifier: sampleId
        });
        expResults.push(dataSummaryCCEPoint);
      });
    }

    const expResultsWithIdentifiers = this.projectsListService.AttachExperimentSampleIdentifiers(
      expResults,
      labReportData.dataLabTest
    );

    //Sort report based on SeqNo
    labReportData.expResults = this.projectsListService.SortExpResultsBySequence(
      expResultsWithIdentifiers,
      labTestArray
    );

    if (this.preview) {

      await this.PreviewReport(labReportData, element.reportSampletype ?? '')

    } else {

      await this.reportService.GenerateReport(labReportData, pdfSelected, excelSelected, element.reportSampletype ?? '');
      const labTestEmail: LabTestEmail = {
        wellName: element.wellName,
        cylinder: element.cylinder
      }

      this.labTestListService.LabTestGenerateReportMail(labTestEmail).subscribe(
        res => {
          if (res.isSuccess) {
            // success response
          }
        }
      );
    }
  }

  async PreviewReport(labTestData: LabTestReportData, reportType: string) {

    const blob = await this.reportPDFBuildersService.GeneratePdf(labTestData, reportType.toLowerCase(), true);

    if (!(blob instanceof Blob)) {
      return;
    }
    // this.pdfData = await blob.arrayBuffer();
    const buffer = await blob.arrayBuffer();
    this.pdfData = new Uint8Array(buffer);
    this.openPreviewDialog();

  }

  openPreviewDialog() {
    this.dialog.open(this.legendDialogPrivew, {
      width: '90vw',
      height: '80vh'
    });
  }

  CompleteProject(data: ProjectWithLabTest) {
    const canCompleteProject = this.projectsListService.CanCompleteProject(data);
    if (!canCompleteProject) {
      this.toastr.error(MC.markAllSamplesCompletedToCompleteTheProject);
    }
    else {
      const updateStatus = this.projectsListService.BuildCompleteProjectStatusUpdate(data.projectId, this.userId);
      this.projectService.UpdateProjectStatus(updateStatus).subscribe(
        res => {
          if (res.isSuccess) {
            this.toastr.success(MC.projectCompletedSuccessfully);
            this.RefreshProjectist();
          }
        }
      );
    }
  }

  private RefreshProjectist() {
    this.sharedService.NavigateToProjectList();
    this.GetProjectsListData();
  }

  ClearCanvasIfExists(arg: ElementRef<HTMLCanvasElement>): void {
    const canvas = arg?.nativeElement;

    if (!canvas) return;

    const ctx = canvas?.getContext(projectListConstants.twoD);
    ctx?.clearRect(NUMBERS_CONSTANTS.zero, NUMBERS_CONSTANTS.zero, canvas?.width, canvas?.height);
  }

  GenerateReportCCEGraph(cceResult: BPTable[]) {
    Chart.register(ChartDataLabels);
    this.graphImages = [];
    if (this.chartList.length > NUMBERS_CONSTANTS.zero) {
      this.chartList.forEach(chart => {
        if (chart && typeof (chart as Chart).destroy === decontaminationConstants.function) {
          (chart as Chart).destroy();
        }
      });
      this.chartList = [];
    }

    const plotOilData = cceResult as BPTable[];
    //Plot Oil
    this.ClearCanvasIfExists(this.plotOilChart1Ref);
    const canvasPO1 = this.plotOilChart1Ref?.nativeElement;
    const ctxPO1 = canvasPO1?.getContext(projectListConstants.twoD);
    if (!ctxPO1) {
      return;
    }
    this.ClearCanvasIfExists(this.plotOilChart2Ref);
    const canvasPO2 = this.plotOilChart2Ref?.nativeElement;
    const ctxPO2 = canvasPO2?.getContext(projectListConstants.twoD);
    if (!ctxPO2) {
      return;
    }
    const chartPlotOil = this.cceHttp.CreateChartPlotsOilReport(plotOilData, ctxPO1, ctxPO2);

    const canvasPO1Ref = this.plotOilChart1Ref?.nativeElement as HTMLCanvasElement;
    const chartImagePO1 = this.CanvasToHighResDataURL(canvasPO1Ref, NUMBERS_CONSTANTS.two, projectListConstants.imageType, NUMBERS_CONSTANTS.reportImageQuality);
    this.graphImages.push(chartImagePO1);
    const canvasPO2Ref = this.plotOilChart2Ref?.nativeElement as HTMLCanvasElement;
    const chartImagePO2 = this.CanvasToHighResDataURL(canvasPO2Ref, NUMBERS_CONSTANTS.two, projectListConstants.imageType, NUMBERS_CONSTANTS.reportImageQuality);
    this.graphImages.push(chartImagePO2);

    this.chartList.push(chartPlotOil[0], chartPlotOil[1]);
  }

  GenerateReportCCEDewPointGraph(cceDewpointResult: DPTable[]) {
    Chart.register(ChartDataLabels);
    this.graphImages = [];
    if (this.chartList.length > NUMBERS_CONSTANTS.zero) {
      this.chartList.forEach(chart => {
        if (chart && typeof (chart as Chart).destroy === decontaminationConstants.function) {
          (chart as Chart).destroy();
        }
      });
      this.chartList = [];
    }

    const plotOilData = cceDewpointResult as DPTable[];
    //Plot Oil
    this.ClearCanvasIfExists(this.cceDewPointChart1Ref);
    const canvasPO1 = this.cceDewPointChart1Ref?.nativeElement;
    const ctxPO1 = canvasPO1?.getContext(projectListConstants.twoD);
    if (!ctxPO1) {
      return;
    }
    this.ClearCanvasIfExists(this.cceDewPointChart2Ref);
    const canvasPO2 = this.cceDewPointChart2Ref?.nativeElement;
    const ctxPO2 = canvasPO2?.getContext(projectListConstants.twoD);
    if (!ctxPO2) {
      return;
    }
    const chartPlotOil = this.cceDewPointHttp.CreateDewPointChartPlotsGasReport(plotOilData, ctxPO1, ctxPO2);
    const canvasPO1Ref = this.cceDewPointChart1Ref?.nativeElement as HTMLCanvasElement;
    const chartImagePO1 = this.CanvasToHighResDataURL(canvasPO1Ref, NUMBERS_CONSTANTS.two, projectListConstants.imageType, NUMBERS_CONSTANTS.reportImageQuality);
    this.graphImages.push(chartImagePO1);
    const canvasPO2Ref = this.cceDewPointChart2Ref?.nativeElement as HTMLCanvasElement;
    const chartImagePO2 = this.CanvasToHighResDataURL(canvasPO2Ref, NUMBERS_CONSTANTS.two, projectListConstants.imageType, NUMBERS_CONSTANTS.reportImageQuality);
    this.graphImages.push(chartImagePO2);
    this.chartList.push(chartPlotOil[0], chartPlotOil[1]);
  }

  GenerateReportBCAGraph(compRecombQAQCFlashedSample: CompRecombQAQCFlashedSampleModel[]) {
    Chart.register(ChartDataLabels);
    this.graphImages = [];
    if (this.chartList.length > NUMBERS_CONSTANTS.zero) {
      if (typeof this.projectsListService.DestroyCharts === 'function') {
        this.projectsListService.DestroyCharts(this.chartList);
      } else {
        this.chartList.forEach((chart) => {
          if (chart && typeof (chart as Chart).destroy === 'function') {
            (chart as Chart).destroy();
          }
        });
      }
      this.chartList = [];
    }

    //Results Graph
    const originalMatarialBalanceData = typeof this.projectsListService.BuildMaterialBalancePlotData === 'function'
      ? this.projectsListService.BuildMaterialBalancePlotData(compRecombQAQCFlashedSample)
      : compRecombQAQCFlashedSample
        .filter(x => x.compound.toLowerCase() !== projectListConstants.c11 && x.compound.toLowerCase() !== projectListConstants.c12)
        .map((x) => ({
          x: Number(x.xz.toFixed(NUMBERS_CONSTANTS.four)),
          y: Number(x.yz.toFixed(NUMBERS_CONSTANTS.four)),
          compound: x.compound,
        }));
    const p2Data = [{
      x: NUMBERS_CONSTANTS.one,
      y: NUMBERS_CONSTANTS.one,
      compound: ''
    }];

    this.ClearCanvasIfExists(this.materialBalanceResultRef);
    const canvasRMB = this.materialBalanceResultRef?.nativeElement;
    const ctxMatarialBalance = canvasRMB?.getContext(projectListConstants.twoD);
    if (!ctxMatarialBalance) {
      return;
    }
    const chartMB = this.bcaHttp.CreateResultsMaterialBalanceReportGraph(ctxMatarialBalance, originalMatarialBalanceData, p2Data, '', projectListConstants.xiZi, projectListConstants.yiZi);

    const canvas = this.materialBalanceResultRef?.nativeElement as HTMLCanvasElement;
    const chartImageMB = this.CanvasToHighResDataURL(canvas, NUMBERS_CONSTANTS.two, projectListConstants.imageType, NUMBERS_CONSTANTS.reportImageQuality);
    this.graphImages.push(chartImageMB);
    this.chartList.push(chartMB);

    //hoffman Factor Plot
    const hoffmanData = typeof this.projectsListService.BuildHoffmanPlotData === 'function'
      ? this.projectsListService.BuildHoffmanPlotData(compRecombQAQCFlashedSample)
      : {
        primary: compRecombQAQCFlashedSample
          .filter(x => x.compound.toLowerCase() !== projectListConstants.c11 && x.compound.toLowerCase() !== projectListConstants.c12)
          .map((x) => ({ x: x.f, y: x.k, compound: x.compound })),
        lightHydrocarbonOnly: compRecombQAQCFlashedSample
          .map((x) => ({ x: x.f, y: x.k, compound: x.compound }))
          .filter(data => (projectListConstants.lightHydrocarbons as readonly string[]).includes(data.compound))
      };
    const hoffmanPlotDataSet1 = hoffmanData.primary;
    const hoffmanPlotDataSet2 = hoffmanData.lightHydrocarbonOnly;


    this.ClearCanvasIfExists(this.hoffmanFactorResultRef);
    const canvasRHF = this.hoffmanFactorResultRef?.nativeElement;
    const ctxHoffmanFactor = canvasRHF?.getContext(projectListConstants.twoD);
    if (!ctxHoffmanFactor) {
      return;
    }
    const chartHF = this.bcaHttp.CreateResultsHoffmanPlotReportGraph(ctxHoffmanFactor, hoffmanPlotDataSet1, hoffmanPlotDataSet2, '', projectListConstants.hoffmanFactor, projectListConstants.kYOverX);


    const canvasHF = this.hoffmanFactorResultRef?.nativeElement as HTMLCanvasElement;
    const chartImageHF = this.CanvasToHighResDataURL(canvasHF, NUMBERS_CONSTANTS.two, projectListConstants.imageType, NUMBERS_CONSTANTS.reportImageQuality);

    this.graphImages.push(chartImageHF);
    this.chartList.push(chartHF);
  }

  GenerateReportSeparatorOilGraph(compRecombQAQCFlashedSample: SeparatorOilGraphModel[]) {
    Chart.register(ChartDataLabels);
    this.graphImages = [];
    if (this.chartList.length > NUMBERS_CONSTANTS.zero) {
      if (typeof this.projectsListService.DestroyCharts === 'function') {
        this.projectsListService.DestroyCharts(this.chartList);
      } else {
        this.chartList.forEach((chart) => {
          if (chart && typeof (chart as Chart).destroy === 'function') {
            (chart as Chart).destroy();
          }
        });
      }
      this.chartList = [];
    }

    //Results Graph
    const originalMatarialBalanceData = typeof this.projectsListService.BuildMaterialBalancePlotData === 'function'
      ? this.projectsListService.BuildMaterialBalancePlotData(compRecombQAQCFlashedSample)
      : compRecombQAQCFlashedSample
        .filter(x => x.compound.toLowerCase() !== projectListConstants.c11 && x.compound.toLowerCase() !== projectListConstants.c12)
        .map((x) => ({
          x: Number(x.xz.toFixed(NUMBERS_CONSTANTS.four)),
          y: Number(x.yz.toFixed(NUMBERS_CONSTANTS.four)),
          compound: x.compound,
        }));
    const p2Data = [{
      x: NUMBERS_CONSTANTS.one,
      y: NUMBERS_CONSTANTS.one,
      compound: ''
    }];

    this.ClearCanvasIfExists(this.materialBalanceResultRef);
    const canvasRMB = this.materialBalanceResultRef?.nativeElement;
    const ctxMatarialBalance = canvasRMB?.getContext(projectListConstants.twoD);
    if (!ctxMatarialBalance) {
      return;
    }
    const chartMB = this.projectHttp.CreateResultsMaterialBalanceReportGraph(ctxMatarialBalance, originalMatarialBalanceData, p2Data, '', projectListConstants.xiZi, projectListConstants.yiZi);

    const canvas = this.materialBalanceResultRef?.nativeElement as HTMLCanvasElement;
    const chartImageMB = this.CanvasToHighResDataURL(canvas, NUMBERS_CONSTANTS.two, projectListConstants.imageType, NUMBERS_CONSTANTS.reportImageQuality);
    this.graphImages.push(chartImageMB);
    this.chartList.push(chartMB);

    //hoffman Factor Plot
    const hoffmanData = typeof this.projectsListService.BuildHoffmanPlotData === 'function'
      ? this.projectsListService.BuildHoffmanPlotData(compRecombQAQCFlashedSample)
      : {
        primary: compRecombQAQCFlashedSample
          .filter(x => x.compound.toLowerCase() !== projectListConstants.c11 && x.compound.toLowerCase() !== projectListConstants.c12)
          .map((x) => ({ x: x.f, y: x.k, compound: x.compound })),
        lightHydrocarbonOnly: compRecombQAQCFlashedSample
          .map((x) => ({ x: x.f, y: x.k, compound: x.compound }))
          .filter(data => (projectListConstants.lightHydrocarbons as readonly string[]).includes(data.compound))
      };
    const hoffmanPlotDataSet1 = hoffmanData.primary;
    const hoffmanPlotDataSet2 = hoffmanData.lightHydrocarbonOnly;


    this.ClearCanvasIfExists(this.hoffmanFactorResultRef);
    const canvasRHF = this.hoffmanFactorResultRef?.nativeElement;
    const ctxHoffmanFactor = canvasRHF?.getContext(projectListConstants.twoD);
    if (!ctxHoffmanFactor) {
      return;
    }
    const chartHF = this.projectHttp.CreateResultsHoffmanPlotReportGraph(ctxHoffmanFactor, hoffmanPlotDataSet1, hoffmanPlotDataSet2, '', projectListConstants.hoffmanFactor, projectListConstants.kYOverX);

    const canvasHF = this.hoffmanFactorResultRef?.nativeElement as HTMLCanvasElement;
    const chartImageHF = this.CanvasToHighResDataURL(canvasHF, NUMBERS_CONSTANTS.two, projectListConstants.imageOrPng, NUMBERS_CONSTANTS.onePointZero);

    this.graphImages.push(chartImageHF);
    this.chartList.push(chartHF);
  }

  private CreateViscosityGraphImages(emvViscosityData: EMVViscosityData): Promise<string[]> {
    return new Promise((resolve) => {
      Chart.register(ChartDataLabels);
      // use local array
      const images: string[] = [];

      // ensure canvas exists (you can create a hidden one if needed)
      const canvas = this.viscosityChartRef?.nativeElement as HTMLCanvasElement;
      const ctx = canvas?.getContext(projectListConstants.twoD);
      if (!ctx) {
        return;
      }
      const existing = Chart.getChart(canvas);
      if (existing) existing.destroy();

      const chart = this.viscosityHttp.CreateResultsViscosityReportGraph(ctx, emvViscosityData);

      const canvasMulti = this.viscosityChartRef?.nativeElement as HTMLCanvasElement;
      const chartImagePO1 = this.CanvasToHighResDataURL(canvasMulti, NUMBERS_CONSTANTS.two, projectListConstants.imageType, NUMBERS_CONSTANTS.reportImageQuality);
      images.push(chartImagePO1);
      resolve(images);
      chart.update();
    });
  }

  TransformComponents(components: ComponentItem[]): FractionComponent[] {
    return this.projectsListService.TransformComponents(components);
  }

  GenerateReportSummaryCCEGraph(cceResult: SummaryOfBPTable[]) {
    Chart.register(ChartDataLabels);
    this.graphImages = [];
    if (this.chartList.length > NUMBERS_CONSTANTS.zero) {
      this.chartList.forEach(chart => {
        if (chart && typeof (chart as Chart).destroy === decontaminationConstants.function) {
          (chart as Chart).destroy();
        }
      });
      this.chartList = [];
    }

    const plotOilData = cceResult as SummaryOfBPTable[];
    //Plot Oil
    this.ClearCanvasIfExists(this.summaryOfCCEChartRef);
    const canvasPO1 = this.summaryOfCCEChartRef?.nativeElement;

    const ctxPO1 = canvasPO1?.getContext(projectListConstants.twoD);
    if (!ctxPO1) {
      return;
    }

    const chartPlotOil = this.cceHttp.CreateSummaryChartPlotsOilReport(plotOilData, ctxPO1);

    const canvasMulti = this.summaryOfCCEChartRef?.nativeElement as HTMLCanvasElement;
    const chartImagePO1 = this.CanvasToHighResDataURL(canvasMulti, NUMBERS_CONSTANTS.two, projectListConstants.imageType, NUMBERS_CONSTANTS.reportImageQuality);

    this.graphImages.push(chartImagePO1);
    this.chartList.push(chartPlotOil);
  }

  GenerateReportDecontaminationGraph(cceResult: DeContaminationChart[]) {
    Chart.register(ChartDataLabels);
    this.graphImages = [];
    if (this.chartList.length > NUMBERS_CONSTANTS.zero) {
      this.chartList.forEach(chart => {
        if (chart && typeof (chart as Chart).destroy === decontaminationConstants.function) {
          (chart as Chart).destroy();
        }
      });
      this.chartList = [];
    }

    const plotOilData = cceResult as DeContaminationChart[];

    const canvas = this.decontDeadOilChartRef?.nativeElement as HTMLCanvasElement;
    const existing = Chart.getChart(canvas);

    existing?.destroy();

    const canvasLive = this.decontLiveFluidChartRef?.nativeElement as HTMLCanvasElement;
    const existingLive = Chart.getChart(canvasLive);

    existingLive?.destroy();

    this.ClearCanvasIfExists(this.decontDeadOilChartRef);
    const canvasPO1 = this.decontDeadOilChartRef?.nativeElement;
    canvasPO1.width = NUMBERS_CONSTANTS.sixHundred;
    canvasPO1.height = NUMBERS_CONSTANTS.sixHundred;
    const ctxPO1 = canvasPO1?.getContext(projectListConstants.twoD);
    if (!ctxPO1) {
      return;
    }
    this.ClearCanvasIfExists(this.decontLiveFluidChartRef);
    const canvasPO2 = this.decontLiveFluidChartRef?.nativeElement;
    canvasPO2.width = NUMBERS_CONSTANTS.sixHundred;
    canvasPO2.height = NUMBERS_CONSTANTS.sixHundred;
    const ctxPO2 = canvasPO2?.getContext(projectListConstants.twoD);
    if (!ctxPO2) {
      return;
    }
    const chartPlotOil = this.decontaminationHttp.CreateChartdecontaminationReport(plotOilData, ctxPO1, ctxPO2);

    const chartImagePO1 = (this.decontDeadOilChartRef?.nativeElement as HTMLCanvasElement).toDataURL(projectListConstants.imagePng);
    this.graphImages.push(chartImagePO1);
    const chartImagePO2 = (this.decontLiveFluidChartRef?.nativeElement as HTMLCanvasElement).toDataURL(projectListConstants.imagePng);
    this.graphImages.push(chartImagePO2);
    this.chartList.push(chartPlotOil[0], chartPlotOil[1]);
  }

  GenerateSwellingReportGraph(swellingResult: Vw_SwellReportData[]) {
    Chart.register(ChartDataLabels);
    this.graphImages = [];
    if (this.chartList.length > NUMBERS_CONSTANTS.zero) {
      this.chartList.forEach(chart => {
        if (chart && typeof (chart as Chart).destroy === decontaminationConstants.function) {
          (chart as Chart).destroy();
        }
      });
      this.chartList = [];
    }

    const plotOilData = swellingResult as Vw_SwellReportData[];

    this.ClearCanvasIfExists(this.swellingChartRef);
    const canvasPO1 = this.swellingChartRef?.nativeElement;
    const ctxPO1 = canvasPO1?.getContext(projectListConstants.twoD);
    if (!ctxPO1) {
      return;
    }
    const chartPlotOil = this.swellingHttp.CreateSwellingChartReport(plotOilData, ctxPO1);
    const chartImagePO1 = (this.swellingChartRef?.nativeElement as HTMLCanvasElement).toDataURL(projectListConstants.imagePng);
    this.graphImages.push(chartImagePO1);
    this.chartList.push(chartPlotOil);
  }

  GenerateRFPODReport(element: LabTestList) {
    this.loadingService.ShowLoadingSpinner();
    this.rfpodService.GenerateProjectRFPODReport(element.projectId)
      .pipe(finalize(() => { this.loadingService.HideLoadingSpinner(); }))
      .subscribe({
        next: (res) => {
          if (res.isSuccess && Array.isArray(res.result) && res.result.length > NUMBERS_CONSTANTS.zero) {
            this.rfpodService.DownloadRFPODReports(res.result as RFPODReport[]);
            // this.toastr.success(MC.rfpodReportGeneratedSuccessfully);
          }
          else {
            this.toastr.error(MC.errorInGeneratingRfpodReport);
          }
        },
        error: () => {
          this.loadingService.HideLoadingSpinner();
        }
      });
  }

  GenerateCommentsHistoryReport(element: ProjectWithLabTest) {
    this.projectService.GetProjectComments(element.projectId).subscribe(
      res => {
        if (res.isSuccess && res.result) {
          this.reportService.GenerateProjectCommentsReport(element.projectNumber!, res.result);
        }
      }
    );
  }
  OnCountryChange(event: Event) {
    const target = event.target as HTMLSelectElement;
    this.selectedCountryId = this.countries.find(x => x.countryName === target.value)?.countryId ?? null;
    if (this.selectedCountryId !== null && this.selectedCountryId !== undefined) {
      this.GetWells(this.selectedCountryId);
      this.wellsLookup = this.wells;
    } else {
      this.wellsLookup = this.projectsListService.BuildDefaultWellsLookup();
    }
  }

  GetCountries() {
    this.selectedCountryId = NUMBERS_CONSTANTS.zero;
    this.projectService.GetCountriesList().subscribe(res => {
      if (res.result !== null) {
        this.countries = this.projectsListService.BuildCountriesLookup(res.result as CountryModel[]);
      }
    });
  }

  GetWells(countryId: number) {
    this.projectService.GetWellsList(countryId).subscribe(res => {
      if (res.result !== null) {
        this.wells = this.projectsListService.BuildWellsLookup(res.result as WellModel[]);
        this.wellsLookup = this.wells;
      }
    });
  }

  GetStatus() {
    this.projectService.GetStatusList().subscribe(() => {

      if (this.projectService.statusList$ !== null) {
        this.statusLookup = this.projectsListService.BuildStatusLookup(this.projectService.statusList$.value as StatusModel[]);
      }
    });
  }

  private WellMatchesToken1 = (well: WellProjectsList, tok: string): boolean =>
    this.projectsListService.WellMatchesToken1(well, tok);

  private ShowWell = (well: WellProjectsList, filters: Filters): boolean =>
    this.projectsListService.ShowWell(well, filters);

  private FilterProjectsForWell = (projects: ProjectWithLabTest[], filters: Filters): ProjectWithLabTest[] =>
    this.projectsListService.FilterProjectsForWell(projects, filters);

  ResetFilters(): void {
    this.wellsLookup = this.projectsListService.BuildDefaultWellsLookup();
    this.filterForm.reset({
      search: '',
      country: projectListConstants.al,
      well: projectListConstants.al,
      dateRange: { start: null, end: null },
      status: projectListConstants.al
    });

    const { start, end } = this.sharedService.GetSameDayLastMonthRange(new Date());

    this.filterForm.patchValue({ dateRange: { start, end } });
  }

  // charts code

  private UpdateChartsFrom(wellsList: WellProjectsList[]): void {
    if (!wellsList?.length) {
      this.pendingStatusCounts = null;
      this.pendingWellCounts = null;
      if (this.statusChart) {
        this.statusChart.destroy();
        this.statusChart = undefined;
      }
      if (this.wellChart) {
        this.wellChart.destroy();
        this.wellChart = undefined;
      }
      this.chartLegendListAll = [];
      this.dataSource1.data = [];
      return;
    }

    const projects = (wellsList ?? []).flatMap(w =>
      this.FilterProjectsForWell(w.projects ?? [], this.filterForm.value)
    );

    this.pendingStatusCounts = this.projectsListService.ComputeStatusCounts(projects);
    this.pendingWellCounts = this.projectsListService.ComputeWellCounts(wellsList);

    this.TryRenderCharts();
  }

  private TryRenderCharts(): void {
    let pending = false;

    if (this.pendingStatusCounts) {
      const rendered = this.RenderStatusPie(this.pendingStatusCounts);
      if (rendered) {
        this.pendingStatusCounts = null;
      } else {
        pending = true;
      }
    }

    if (this.pendingWellCounts) {
      const rendered = this.RenderWellPie(this.pendingWellCounts);
      if (rendered) {
        this.pendingWellCounts = null;
      } else {
        pending = true;
      }
    }

    if (pending) {
      this.ScheduleChartRenderRetry();
    }
  }

  private ScheduleChartRenderRetry(): void {
    if (this.chartRenderRetryHandle) {
      clearTimeout(this.chartRenderRetryHandle);
    }

    this.chartRenderRetryHandle = setTimeout(() => {
      this.chartRenderRetryHandle = null;
      this.cdr.detectChanges();
      this.TryRenderCharts();
    }, NUMBERS_CONSTANTS.zero);
  }

  private RenderStatusPie(counts: { completed: number; inprogress: number; ready: number }): boolean {
    const canvas = this.statusPieChart?.nativeElement;
    const ctx = canvas?.getContext(projectListConstants.twoD);
    if (!ctx) {
      return false;
    }

    if (this.statusChart) { this.statusChart.destroy(); }
    this.statusChart = this.projectsListService.BuildStatusPieChart(
      ctx, counts, this.STATUS_COLORS, (arr) => this.sharedService.Sum(arr)
    );
    return true;
  }


  private RenderWellPie(wells: { name: string | null; count: number }[]): boolean {
    const canvas = this.wellPieChart?.nativeElement;
    if (!canvas) return false;

    const ctx = canvas?.getContext(projectListConstants.twoD);
    if (!ctx) return false;

    if (this.wellChart) { this.wellChart.destroy(); }
    const result = this.projectsListService.BuildWellPieChart(
      ctx, wells, (arr) => this.sharedService.Sum(arr)
    );
    this.wellChart = result.chart;
    this.chartLegendListAll = result.legendData;
    this.dataSource1.data = this.chartLegendListAll;
    this.dataSource1.paginator = this.paginator1;
    return true;
  }

  OpenLegendDialog() {
    const dialogRef = this.dialog.open(this.legendDialog, {
      width: cceDPConstants.dialogWidth,
      disableClose: true
    });

    dialogRef.afterOpened().subscribe(() => {
      this.dataSource1.paginator = this.paginator1;
    });
  }

  get PaginatedData() {
    if (!this.paginator1)
      return this.chartLegendListAll;
    const start = this.paginator1.pageIndex * this.paginator1.pageSize;
    const end = start + this.paginator1.pageSize;
    return this.chartLegendListAll.slice(start, end);
  }

  GenerateUserReport() {

    const data = this.filterForm.value;

    const { fromDate, toDate, wellName, country, status } = this.projectsListService.BuildUserReportQuery(
      data,
      (date) => this.sharedService.ToLocalDateStringOrNull(date),
      (date) => this.sharedService.ParseToUtcDate(date),
      (value, fallback) => this.sharedService.NormalizeString(value, fallback)
    );

    if (!this.projectsListService.IsUserReportDateRangeValid(
      fromDate,
      toDate,
      (startDate, endDate, inclusive) => this.sharedService.DiffDays(startDate, endDate, inclusive)
    )) {
      this.toastr.error(MC.selectADateRangeWithin31DaysForUserReport);
      return;
    }

    this.projectService.GetUserInfo(fromDate, toDate, wellName, country, status).subscribe((response) => {
      if (response.result) {
        this.reportService.GenerateUserReportExcel(response.result as VwUserReportView[]);
      }
    });
  }

  CanvasToHighResDataURL(
    canvas: HTMLCanvasElement,
    scale: number,
    mime: string,// = projectListConstants.imageOrPng,
    quality:number// = NUMBERS_CONSTANTS.onePointZero
  ) {
    return this.projectsListService.CanvasToHighResDataURL(canvas, scale, mime, quality);
  }

  zoom = 1;

  page = 1;
  totalPages = 0;


  onPdfLoadComplete(pdf: PDFDocumentProxy): void {
    this.totalPages = pdf.numPages;
  }


  zoomIn(): void {
    this.zoom += 0.25;
  }

  zoomOut(): void {
    if (this.zoom > 0.5) {
      this.zoom -= 0.25;
    }
  }

  nextPage(): void {
    if (this.page < this.totalPages) {
      this.page++;
    }
  }

  prevPage(): void {
    if (this.page > 1) {
      this.page--;
    }
  }

}